export const ROUTE_APPROVALS = '/approvals';
